<app-modal title="{{ 'Assign stores to ' + user().email }}" #modalComponent>
  <form (ngSubmit)="onSubmit()" #f="ngForm" class="p-3">

    <app-checkbox-group
            [options]="storeIdsOptions()"
            [selectedValues]="selectedStoreIds()"
            [hasSeveralColumns]="true"
            (checkboxToggled)="onStoreIdsChange($event)">
    </app-checkbox-group>

    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent.activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="!f.valid || loading()">Save
      </button>
    </div>
  </form>
</app-modal>